module.exports = __webpack_public_path__ + "1213a7925536a570a0c7878cad7f9725.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox_connecting_2x.gif
// module id = 155
// module chunks = 1 2 3 4